import { styled, Theme } from '@nexelem/deprecated-theme';

const OPTION_HEIGHT = 11;
const JUMBO_OPTION_HEIGHT = 18;
const NUMBER_OF_DISPLAYED_OPTION = 6;

export const SelectFieldListbox = styled('ul', {
  shouldForwardProp: (propName: string) => !['isJumbo', 'disableOptionsLimit'].includes(propName),
})<{ isJumbo?: boolean; disableOptionsLimit?: boolean }>(({ theme, isJumbo, disableOptionsLimit }) => {
  const typedTheme = theme as Theme;
  const { getColor, hexToRGB } = typedTheme.palette;
  const { defaultState, focus, hover } = typedTheme.client.inputs.selectFieldItem;

  return {
    '&': {
      maxHeight: !disableOptionsLimit && theme.spacing(OPTION_HEIGHT * NUMBER_OF_DISPLAYED_OPTION),
      color: getColor(defaultState.color),
      backgroundColor: getColor(defaultState.backgroundColor),
    },
    '&& .MuiAutocomplete-option': {
      ...(isJumbo ? typedTheme.typography.sourceSansPro20Regular : typedTheme.typography.sourceSansPro16Regular),
      boxSizing: 'border-box',
      lineHeight: '1.25rem',
      padding: typedTheme.spacing(3, 4),
      minHeight: typedTheme.spacing(isJumbo ? JUMBO_OPTION_HEIGHT : OPTION_HEIGHT),
    },
    '&& .MuiFormControlLabel-root': {
      margin: typedTheme.spacing(0),
      '&& .MuiTypography-root': {
        ...(isJumbo ? typedTheme.typography.sourceSansPro20Regular : typedTheme.typography.sourceSansPro16Regular),
      },
    },
    '&& .MuiFormControlLabel-root .MuiFormControlLabel-label': {
      ...(isJumbo ? typedTheme.typography.sourceSansPro20Regular : typedTheme.typography.sourceSansPro16Regular),
    },
    '&& .MuiAutocomplete-option .MuiCheckbox-root': {
      padding: typedTheme.spacing(0),
      paddingRight: typedTheme.spacing(2),
    },
    '&& .MuiAutocomplete-option[aria-selected="true"]': {
      backgroundColor: hexToRGB(getColor(focus), 0.9),
    },
    '&& .MuiAutocomplete-option.Mui-focused': {
      backgroundColor: hexToRGB(getColor(hover), 0.5),
    },
    '&& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
      backgroundColor: hexToRGB(getColor(focus), 0.9),
    },
  };
});
